
export default {
    props: ['mod', 'error', 'solid', 'disabled', 'submit', 'noCorner'],
    computed: {
        classObject(){
            return {
                'btn_big': this.mod === 'big',
                'btn_small': this.mod === 'small',
                'btn_solid': this.solid,
                'btn_error': this.error,
                'btn_no-corner': this.noCorner,
            }
        }
    }
}
